<div *ngFor="let error of errorList">
    <span class="fad fa-exclamation-triangle"></span> {{ error.name }}:
    {{ error.message }}
</div>
<div
    *ngIf="authorisationValidity !== 'VALID' && authorisationValidity !== 'NA'"
>
    <span class="fad fa-exclamation-triangle"></span>
    {{ validityLookup[authorisationValidity] }}
</div>

<div
    *ngIf="
        errorList.length === 0 &&
        (authorisationValidity === 'VALID' || authorisationValidity === 'NA')
    "
>
    <span class="fa fa-check green-tick"></span> No errors
</div>
